/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Col, Row, Table } from 'antd'
import { observer } from 'mobx-react-lite'
import LanguageSelector from '../../../components/Shared/LanguageSelector'
import {
	GeneralContentWrapper,
	GeneralTourTitle
} from '../../../components/Shared/GeneralComponents'
import { useStores } from '../../../cls/stores/MobXProvider'
import { getTourArrayByKeys } from '../../../stores/tour/config'
import GetStarted from './get-started/GetStarted'
import { stripeSuccessHandler } from '../../../stores/subscriptions/actions'
import { useSmartTranslation } from '../../../cls/TranslationContext'
import OverviewData from './OverviewData'
import CardData from './CardData'
// import { smartT } from '../../../config/translationGlobal'
/**
 * @component DashboardMain
 * @description
 * Main dashboard entry point for logged-in users. Displays:
 * - A welcome header with user's name.
 * - A language selector.
 * - A "Get Started" section for users with pending onboarding actions.
 * - (Optionally) a permissions table for admins/superadmins.
 * - Automatically handles Stripe checkout redirection feedback.
 * - Starts a UI onboarding tour depending on context.

 * @features
 * - Reacts to URL parameters (`stripe-checkout-success`, `priceId`) to refresh subscriptions or display feedback.
 * - Utilizes MobX `observer` to re-render on observable changes.
 * - Localized using `react-i18next`.
 * - Supports user-specific tour via `tourStore`.

 * @returns {React.ReactElement} A fully structured user dashboard interface.
 */
const DashboardMain = () => {
	// const { t } = useSmartTranslation()

	const { t } = useSmartTranslation()
	const navigate = useNavigate()
	const { users, appType, tourStore, getPlanById } = useStores()
	const { appIsClient } = appType
	const { loggedInUser, loggedInUserId } = users

	// get url params stripe-checkout-success & priceId
	const { search } = useLocation()
	const params = new URLSearchParams(search)
	const stripeCheckoutSuccess = params.get('stripe-checkout-success')

	// console.log(
	// 'smartT ::',
	// t('__manage%_user.multiple')
	// // smartT('__nested-example%_user')
	// )

	// console.log('outside components', smartT('__manage%_user.multiple'))

	useEffect(() => {
		if (stripeCheckoutSuccess === 'true') {
			stripeSuccessHandler().then((response) => {
				alert('Payment successful. You can now start using the app.')
				console.log('stripeSuccessHandler response:: ', response)
				// navigate('/dashboard')
			})
		} else if (stripeCheckoutSuccess === 'false') {
			alert('Payment failed or canceled. Please try again.')
			navigate('/dashboard')
		}
	}, [stripeCheckoutSuccess])

	const requiredActions = loggedInUser.requiredActions

	// console.log('loggedInUser', toJS(loggedInUser))
	const showCurentUserPermissions = false // requiredVersion('1.2.0')

	const startTour = () => {
		// FIX THIS: what is menusExpanded supposed to do? Were is it defined, read?
		const expandedKeys = tourStore.sidebarKeys
		const appList = getTourArrayByKeys('appList', ['all'])
		tourStore.startTour('AppList-tour', [...appList])
		tourStore.setMenusExpanded(expandedKeys)
	}

	const startDashboardTour = () => {
		const activeTourKeys = ['intro', 'languageSettings']
		if (showCurentUserPermissions) {
			activeTourKeys.push('dashboardTable')
		}
		if (requiredActions.length > 0) {
			activeTourKeys.push('getStarted')
		}
		const dashboardTour = getTourArrayByKeys('dashboard', activeTourKeys)
		tourStore.startTour('Dashboard tour', [...dashboardTour])
	}

	return (
		<GeneralContentWrapper>
			{/* Heading */}
			<Row gutter={[20, 20]} justify="space-between" align="middle">
				<Col>
					<GeneralTourTitle
						titleProps={{
							id: 'target-dashboard-title',
							text: t('__welcome-single', {
								first: loggedInUser.name
							}),
							style: { marginBottom: '0' }
						}}
						buttonProps={{
							onClick: startDashboardTour
						}}
					/>
					{/* <p>{t('webackit.blog-info')}</p> */}
				</Col>
				<div id="target-language-selector-dashboard">
					<Col>
						{t('single.language.label')}
						: <LanguageSelector />
					</Col>
				</div>
			</Row>
			<div style={{ marginTop: '25px' }} />

			<CardData
				params={{
					user_id: loggedInUserId,
					frequency: 'monthly'
				}}
			/>
			<div style={{ marginTop: '25px' }} />

			{/* <Col>
				<Button onClick={startTour}> Tour App </Button>
			</Col> */}

			<GetStarted />

			{showCurentUserPermissions && (
				<div id="target-table-dashboard">
					<Table
						size="small"
						columns={[
							{
								title: 'Permission',
								dataIndex: 'permission',
								key: 'permission'
							},
							{
								title: 'Status',
								dataIndex: 'status',
								key: 'status'
							}
						]}
						// dataSource should be an array of array and mapped corectly, like: [['loggedInUserId', 'true']]
						dataSource={[
							['loggedInUserId', loggedInUserId],
							['appIsClient', appIsClient],

							['isSuperAdmin', loggedInUser.isSuperAdmin],
							['isAdmin', loggedInUser.isAdmin],

							['isClientAdmin', loggedInUser.isClientAdmin],
							['isClient', loggedInUser.isClient],

							['isTeamAdmin', loggedInUser.isTeamAdmin],
							['isTeam', loggedInUser.isTeam]
						]
							// now we need to map this array and if status is bool type we want to show 'true' or 'false' instead of '0' or '1'
							.map((item) => {
								return {
									permission: item[0],
									key: item[0],
									status:
										typeof item[1] === 'boolean'
											? item[1]
												? 'true'
												: 'false'
											: item[1]
								}
							})}
					/>
				</div>
			)}
			{/* <OverviewData /> */}
		</GeneralContentWrapper>
	)
}

export default observer(DashboardMain)
